import React from 'react';
import './Spinner.css'; // Import your CSS

function Spinner() {
  return <div className="spinner"></div>;
}

export default Spinner;